import {
  CheckCertificate,
  CourseConstants as Constants,
  CourseProgress,
  DownloadCertificate,
  RESET_MY_COURSE,
} from "../constants";
import { courseApi as api } from "../../api";

export const courseAction = {
  all,
  get,
  featured,
  buy_course,
  my_courses,
  get_details,
  clear,
  downloadCertificate,
  checkCourseCompletion,
  getUserCoursesWithProgress,
  resetMyCourse,
  buy_course_free,
};

function all() {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      api._all().then(
        (payload) => {
          dispatch(success(payload));
          resolve(payload);
        },
        (error) => {
          dispatch(failure("Failed"));
          reject(error);
        }
      );
    });
  };
  function success(payload) {
    return { type: Constants.ALL, payload };
  }
  function failure(error) {
    return { type: Constants.FAILED, error };
  }
}

function get(slug) {
  return (dispatch, getState) => {
    const state = getState();
    const userId = state?.auth?.user?.id || null;

    return new Promise((resolve, reject) => {
      api._get(slug, userId).then(
        (payload) => {
          dispatch(success(payload));
          resolve(payload);
        },
        (error) => {
          dispatch(failure("Failed"));
          reject(error);
        }
      );
    });
  };
  function success(payload) {
    return { type: Constants.GET, payload };
  }
  function failure(error) {
    return { type: Constants.FAILED, error };
  }
}

function featured() {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      api._featured().then(
        (payload) => {
          dispatch(success(payload));
          resolve(payload);
        },
        (error) => {
          dispatch(failure("Failed"));
          reject(error);
        }
      );
    });
  };
  function success(payload) {
    return { type: Constants.FEATURED, payload };
  }
  function failure(error) {
    return { type: Constants.FAILED, error };
  }
}

function buy_course(form_data) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      api._buy_course(form_data).then(
        (payload) => {
          dispatch(success(payload));
          resolve(payload);
        },
        (error) => {
          dispatch(failure("Failed"));
          reject(error);
        }
      );
    });
  };
  function success(payload) {
    return { type: Constants.BUY_COURSE, payload };
  }
  function failure(error) {
    return { type: Constants.FAILED, error };
  }
}

function buy_course_free(form_data) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      api._buy_course_free(form_data).then(
        (payload) => {
          dispatch(success(payload));
          resolve(payload);
        },
        (error) => {
          dispatch(failure("Failed"));
          reject(error);
        }
      );
    });
  };
  function success(payload) {
    return { type: Constants.BUY_COURSE, payload };
  }
  function failure(error) {
    return { type: Constants.FAILED, error };
  }
}

function my_courses() {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      api._my_courses().then(
        (payload) => {
          dispatch(success(payload));
          resolve(payload);
        },
        (error) => {
          dispatch(failure("Failed"));
          reject(error);
        }
      );
    });
  };
  function success(payload) {
    return { type: Constants.MY_COURSES, payload };
  }
  function failure(error) {
    return { type: Constants.FAILED, error };
  }
}

function get_details(slug) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      api._get_details(slug).then(
        (payload) => {
          dispatch(success(payload));
          resolve(payload);
        },
        (error) => {
          dispatch(failure("Failed"));
          reject(error);
        }
      );
    });
  };
  function success(payload) {
    return { type: Constants.MY_COURSE_DETAIILS, payload };
  }
  function failure(error) {
    return { type: Constants.FAILED, error };
  }
}

function clear() {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(success());
      resolve();
    });
  };
  function success() {
    return { type: Constants.CLEAR };
  }
}

function downloadCertificate(courseId) {
  return (dispatch) => {
    dispatch(request());
    return new Promise((resolve, reject) => {
      api._downloadCertificate(courseId).then(
        (blob) => {
          dispatch(success(blob));
          resolve(blob);
        },
        (error) => {
          dispatch(failure("Failed to download certificate"));
          reject(error);
        }
      );
    });
  };

  function request() {
    return { type: DownloadCertificate.DOWNLOAD_LOADING };
  }

  function success(blob) {
    return { type: DownloadCertificate.DOWNLOAD_CERTIFICATE, payload: blob };
  }

  function failure(error) {
    return { type: DownloadCertificate.FAILED, error };
  }
}

function checkCourseCompletion(slug) {
  return (dispatch) => {
    dispatch(request());
    return new Promise((resolve, reject) => {
      api._checkCourseCompletion(slug).then(
        (payload) => {
          dispatch(success(payload));
          resolve(payload);
        },
        (error) => {
          dispatch(failure("Failed to check course completion"));
          reject(error);
        }
      );
    });
  };

  function request() {
    return { type: CheckCertificate.LOADING };
  }

  function success(payload) {
    return { type: CheckCertificate.CHECK_CERTIFICATE, payload: payload };
  }

  function failure(error) {
    return { type: CheckCertificate.FAILED, error };
  }
}

function getUserCoursesWithProgress() {
  return (dispatch) => {
    dispatch(request());
    return new Promise((resolve, reject) => {
      api._getUserCoursesWithProgress().then(
        (payload) => {
          dispatch(success(payload));
          resolve(payload);
        },
        (error) => {
          dispatch(failure("Failed to get the course progress"));
          reject(error);
        }
      );
    });
  };

  function request() {
    return { type: CourseProgress.COURSE_PROGRESS_LOADING };
  }

  function success(payload) {
    return { type: CourseProgress.COURSE_PROGRESS, payload: payload };
  }

  function failure(error) {
    return { type: CourseProgress.COURSE_PROGRESS_FAILED, error };
  }
}

function resetMyCourse() {
  return {
    type: RESET_MY_COURSE,
  };
}
